import { animations, delay, duration } from './actions.animations.config';
import store from '@/app/store/store';
import type { ActionDataEditor } from './type';
import { keyRegisterAction } from './actions.config';

const atomDefaultActions: ActionDataEditor[] = [
  {
    key: 'show',
    type: 2,
    name: 'Show Element',
    description: 'Display element',
    settings: [delay, duration],
  },
  {
    key: 'hide',
    type: 2,
    name: 'Hide Element',
    description: 'Display element',
    settings: [delay, duration],
  },
  {
    key: 'toggle',
    type: 2,
    name: 'Toggle Element',
    description: 'Display or hide element',
    settings: [delay, duration],
  },
  {
    key: 'slideUp',
    type: 2,
    name: 'Slide Up',
    description: 'Hide element with a sliding motion',
    settings: [delay, duration],
  },
  {
    key: 'slideDown',
    type: 2,
    name: 'Slide Down',
    description: 'Display element with a sliding motion',
    settings: [delay, duration],
  },
  {
    key: 'slideToggle',
    type: 2,
    name: 'Slide Toggle',
    description: 'Display or hide element with a sliding motion',
    settings: [delay, duration],
  },
  {
    key: 'scrollToId',
    type: 2,
    name: 'Scroll To Target',
    description: 'Scroll to selected target on current page',
    settings: [
      delay,
      duration,
      {
        key: 'marginTop',
        name: 'Margin Top',
        value: 30,
        min: -15,
        max: 300,
        step: 5,
        valueType: 'px',
        type: 'range',
      },
    ],
  },
];

/**
 * get custom Actions
 * @param atomLabel ..
 * @returns .. notdone
 */
export const customActions = (atomLabel = ''): ActionDataEditor[] => {
  const custom = store.getValue(keyRegisterAction) || [];
  if (!atomLabel) {
    return custom;
  }

  const actions = [];
  for (let i = 0; i < custom.length; i++) {
    if (custom[i].atomLabel && custom[i].atomLabel == atomLabel) {
      actions.push(custom[i]);
    }
  }
  return actions;
};

/**
 * convertAnimationsToAction
 * @param animation ..
 * @returns ..
 */
/* const convertAnimationToAction = (animation: TypeAnimation): ActionDataEditor => {
  return {
    key: animation.key,
    type: 1,
    name: animation.name,
    description: animation.description || ""
  };
}; */

/**
 * list Actions;
 * @param atomLabel ..
 * @returns ..
 */
export const listActions = (atomLabel = ''): ActionDataEditor[] => {
  let list: ActionDataEditor[] = [];

  if (animations.length) {
    list = [...animations, ...list];
  }

  if (atomDefaultActions.length) {
    list = [...atomDefaultActions, ...list];
  }

  const custom = customActions(atomLabel);
  if (custom) {
    list = [...custom, ...list];
  }

  return list;
};

/**
 * listActionsByType
 * @param atomLabel .
 * @returns ..
 */
export const listActionsByType = (atomLabel = ''): any => {
  const dataAnimations: ActionDataEditor[] = [];
  const dataActions: ActionDataEditor[] = [];

  const actions = listActions(atomLabel);
  for (let i = 0; i < actions.length; i++) {
    if (actions[i].type == 1) {
      dataAnimations.push(actions[i]);
    } else {
      dataActions.push(actions[i]);
    }
  }

  return {
    animations: dataAnimations,
    actions: dataActions,
  };
};

/**
 * addAction
 * @param key ..
 * @param atomLabel ..
 * @returns ..
 */
export const getActionDataEditorDefault = (key: string, atomLabel = ''): ActionDataEditor => {
  const actions = listActions(atomLabel);
  for (let i = 0; i < actions.length; i++) {
    if (actions[i].key == key) {
      return {
        key: actions[i].key,
        type: actions[i].type,
        name: actions[i].name,
        description: actions[i].description,
        settings: actions[i].settings || [],
      };
    }
  }
  return {
    key: '',
    type: 0,
    name: '',
    description: '',
    settings: [],
  };
};
